import Vue from "vue";
import Router from "vue-router";
import HomePage from "@/components/homepage";
import CloudStandard from "@/components/cloudStandard";
import SupportService from "@/components/supportService";
import DigitalWallet from "@/components/digitalWallet";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      name: "HomePage",
      component: HomePage
    },
    {
      path: "/cloudStandard",
      name: "cloudStandard",
      component: CloudStandard
    },
    // {
    //   path: "/topcreditbank",
    //   name: "Topcreditbank",
    //   component: Topcreditbank
    // },
    {
      path: "/supportService",
      name: "supportService",
      component: SupportService
    },
    {
      path: "/digitalWallet",
      name: "digitalWallet",
      component: DigitalWallet
    },
    // 重定向 到 /
    {
      path: "*",
      redirect: "/"
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js